module.exports = __webpack_public_path__ + "media/bootstrap-icons/pin-angle-fill-7bc0c076.svg";